export default __webpack_public_path__ + "static/media/sort.21d086e2.svg";